import { TableBody, TableEmpty, TableLoading } from '@/ui';

import Row from './Row';

import type { ManageCoach } from '@/store/api/userApi';
import type { FC } from 'react';

import { COACH_COLUMNS } from '@/constants/coaches';

interface ListProps {
  coaches: ManageCoach[];
  isLoading: boolean;
}

const List: FC<ListProps> = ({ coaches = [], isLoading = false }) => {
  if (isLoading) {
    return <TableLoading columns={COACH_COLUMNS.length} />;
  }
  if (!coaches.length) {
    return (
      <TableEmpty
        columns={COACH_COLUMNS.length}
        message="No coaches found ...."
      />
    );
  }

  return (
    <TableBody>
      {coaches.map((coach) => (
        <Row key={`${coach.id}-coach-management`} {...coach} />
      ))}
    </TableBody>
  );
};

export default List;
